export default __webpack_public_path__ + "static/media/4.1da8a4a3.webp";